
import { useState } from 'react';

export default function Stats() {
  const [showParkingInfo, setShowParkingInfo] = useState(false);
  const [showFinanceInfo, setShowFinanceInfo] = useState(false);
  const [showMobileParkingInfo, setShowMobileParkingInfo] = useState(false);
  const [showMobileFinanceInfo, setShowMobileFinanceInfo] = useState(false);

  const stats = [
    {
      number: '8700+',
      label: 'Happy Patients',
      icon: 'ri-user-smile-line'
    },
    {
      number: '5.0',
      label: 'Google Rating',
      icon: 'ri-star-fill'
    },
    {
      number: '15+',
      label: 'Years Experience',
      icon: 'ri-award-line'
    },
    {
      number: '98%',
      label: 'Patient Satisfaction',
      icon: 'ri-heart-line'
    }
  ];

  return (
    <section className="relative py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-[#f8f9fa] to-white">
      <div className="max-w-7xl mx-auto">
        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 mb-8 sm:mb-12">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 text-center"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#d0a24f]/10 rounded-xl sm:rounded-2xl mb-3 sm:mb-4 mx-auto group-hover:bg-[#d0a24f] transition-colors">
                <i className={`${stat.icon} text-xl sm:text-2xl md:text-3xl text-[#d0a24f] group-hover:text-white transition-colors`}></i>
              </div>
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#444c42] mb-1 sm:mb-2">
                {stat.number}
              </div>
              <div className="text-xs sm:text-sm md:text-base text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Mobile/Tablet Buttons - Only visible below lg */}
        <div className="lg:hidden flex flex-col sm:flex-row gap-4 mb-8">
          {/* Free Parking Button */}
          <div className="flex-1">
            <button
              onClick={() => setShowMobileParkingInfo(!showMobileParkingInfo)}
              className="w-full group flex items-center justify-between gap-3 bg-white rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#d0a24f]/10 rounded-xl group-hover:bg-[#d0a24f] transition-colors flex-shrink-0">
                  <i className="ri-parking-box-line text-2xl text-[#d0a24f] group-hover:text-white transition-colors"></i>
                </div>
                <div className="text-left">
                  <div className="text-base font-bold text-[#444c42]">Free Parking</div>
                  <div className="text-sm text-gray-600">Available on-site</div>
                </div>
              </div>
              <i className={`ri-arrow-${showMobileParkingInfo ? 'up' : 'down'}-s-line text-xl text-gray-400 transition-transform flex-shrink-0`}></i>
            </button>
            
            {showMobileParkingInfo && (
              <div className="mt-3 bg-white rounded-xl shadow-xl p-4 border border-gray-100">
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">Three hours of complimentary onsite parking</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">Large, spacious car park for stress-free visits</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">No fees or time limits to worry about</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">Convenient parking right outside the practice</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* 0% Finance Button */}
          <div className="flex-1">
            <button
              onClick={() => setShowMobileFinanceInfo(!showMobileFinanceInfo)}
              className="w-full group flex items-center justify-between gap-3 bg-white rounded-2xl px-6 py-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-[#d0a24f]/10 rounded-xl group-hover:bg-[#d0a24f] transition-colors flex-shrink-0">
                  <i className="ri-percent-line text-2xl text-[#d0a24f] group-hover:text-white transition-colors"></i>
                </div>
                <div className="text-left">
                  <div className="text-base font-bold text-[#444c42]">0% Finance</div>
                  <div className="text-sm text-gray-600">Flexible payment plans</div>
                </div>
              </div>
              <i className={`ri-arrow-${showMobileFinanceInfo ? 'up' : 'down'}-s-line text-xl text-gray-400 transition-transform flex-shrink-0`}></i>
            </button>
            
            {showMobileFinanceInfo && (
              <div className="mt-3 bg-white rounded-xl shadow-xl p-4 border border-gray-100">
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">Spread the cost of your treatment with 0% interest</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">Flexible payment plans available</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">Quick and easy application process</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-check-line text-[#d0a24f] text-xl mt-0.5 flex-shrink-0"></i>
                    <p className="text-sm text-gray-700">No hidden fees or charges</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Benefits Badges - Only visible on desktop (lg and above) */}
        <div className="hidden lg:flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
          {/* Free Parking Badge */}
          <div className="relative">
            <button
              onClick={() => setShowParkingInfo(!showParkingInfo)}
              className="group flex items-center gap-3 bg-white rounded-2xl px-4 sm:px-6 py-3 sm:py-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer w-full sm:w-auto justify-center"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#d0a24f]/10 rounded-xl group-hover:bg-[#d0a24f] transition-colors">
                <i className="ri-parking-box-line text-xl sm:text-2xl text-[#d0a24f] group-hover:text-white transition-colors"></i>
              </div>
              <div className="text-left">
                <div className="text-sm sm:text-base font-bold text-[#444c42]">Free Parking</div>
                <div className="text-xs sm:text-sm text-gray-600">Available on-site</div>
              </div>
              <i className={`ri-arrow-${showParkingInfo ? 'up' : 'down'}-s-line text-lg sm:text-xl text-gray-400 transition-transform`}></i>
            </button>
            
            {showParkingInfo && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-xl p-4 border border-gray-100 z-10 w-full sm:w-80">
                <p className="text-sm text-gray-700 leading-relaxed">
                  Enjoy complimentary parking right at our practice. No need to worry about finding a spot or paying for parking - we've got you covered!
                </p>
              </div>
            )}
          </div>

          {/* 0% Finance Badge */}
          <div className="relative">
            <button
              onClick={() => setShowFinanceInfo(!showFinanceInfo)}
              className="group flex items-center gap-3 bg-white rounded-2xl px-4 sm:px-6 py-3 sm:py-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 cursor-pointer w-full sm:w-auto justify-center"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#d0a24f]/10 rounded-xl group-hover:bg-[#d0a24f] transition-colors">
                <i className="ri-percent-line text-xl sm:text-2xl text-[#d0a24f] group-hover:text-white transition-colors"></i>
              </div>
              <div className="text-left">
                <div className="text-sm sm:text-base font-bold text-[#444c42]">0% Finance</div>
                <div className="text-xs sm:text-sm text-gray-600">Flexible payment plans</div>
              </div>
              <i className={`ri-arrow-${showFinanceInfo ? 'up' : 'down'}-s-line text-lg sm:text-xl text-gray-400 transition-transform`}></i>
            </button>
            
            {showFinanceInfo && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-xl p-4 border border-gray-100 z-10 w-full sm:w-80">
                <p className="text-sm text-gray-700 leading-relaxed">
                  Spread the cost of your treatment with our 0% finance options. Make dental care more affordable with flexible monthly payments that suit your budget.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
